import { useMappedState } from "redux-react-hook";
import * as _ from "lodash";
import React from "react";

import { IStore } from "src/core/shared/store";
import { SupportTicketCreditOptions } from "src/modules/support/api/support.api";

import { useCreditRequestContext } from "../context/CreditRequestContext";
import { ICreditRequestReasonCode } from "../api/credit-request.api";

/**
 * Returns the available credit reasons
 * filtering by ticket type if a ticket type is selected
 */
export const useCreditReasonCodes = (): ICreditRequestReasonCode[] => {
  const { creditReasons, ticketTypes } = useMappedState((store: IStore) => ({
    ticketTypes: store.global.settings?.supportTicketTypes || [],
    creditReasons: store.global.settings?.creditRequestReasonCodes || []
  }));

  const [ creditState ] = useCreditRequestContext();

  const creditReasonsMemo = React.useMemo(() => {
    // find the ticket type if selected
    const ticketType = _.find(ticketTypes, tt => {
      return tt.id === creditState.supportTicket?.supportTicketTypeId;
    });

    // return a filtered list of ticket types
    if (typeof ticketType?.options.allowCredits === "object" && ticketType?.options.allowCredits.reasonCode) {
      return _.filter(creditReasons, cr => cr.code === (ticketType?.options.allowCredits as SupportTicketCreditOptions).reasonCode);
    }

    return creditReasons;
  }, [
    creditReasons,
    creditState.supportTicket?.supportTicketTypeId,
    ticketTypes
  ]);

  return creditReasonsMemo;
};
